

function newsletter(){

    $('.module--newsletter').each(function(){
        var gform = $(this).find('.gravity-form');
        var gformEmail = gform.find('input[type="email"]');
        var gformSubmit = gform.find('input[type="submit"]');
        $(this).find('.input-email').keyup(function(){
            var emailValue = $(this).val();
            gformEmail.val(emailValue);
        })
    
        $('.newsletter-field-group .btn-submit').click(function(){
            gformSubmit.trigger('click');
        })
    })
}

jQuery(document).on('gform_post_render', function(event, form_id, current_page){
 
    newsletter();

});
